/** Mirrors `apps/desktop`'s own `pairing-session.ts` persistence shape — a separate storage key/app, but the same wire shape `POST /api/v1/pair` returns. */
const STORAGE_KEY = "stagvista.display-session";

export interface DisplaySession {
  readonly role: "operator" | "assistant" | "viewer";
  readonly token: string;
  readonly expiresAt: number;
}

export function loadDisplaySession(): DisplaySession | null {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as DisplaySession;
    if (parsed.expiresAt <= Date.now()) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function storeDisplaySession(session: DisplaySession): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}
